export const Enums = {
  projectName: 'Beekeeper',
  errorCodes: {},
  errorCodesMaps: {},
  userHighlightTypes: {},
  userTypes: {},
  ticketHighlightStatuses: {},
  cellSquare: {},
  workShiftIntervalStatuses: {},
  workShiftIntervalSquare: {},
  workShiftTicketsIntervalSquare: {},
  workShiftTicketsIntervalSquareGRS: {},
  workShiftTicketsIntervalMap: {},
  tables: {},
  dates: {
    fullFormat: 'YYYY-MM-DDTHH:mm:ss',
    shortFormat: 'YYYY-MM-DD',
    dateTimeFormat: 'YYYY-MM-DDTHH:mm',
    dateFormat: 'YYYY-MM-DD',
    monthFormat: 'YYYY-MM'
  },
};

Enums.errorCodes[0] = 'Успешно.';
Enums.errorCodes[200000] = 'У вас нет доступа для использования данной функции';
Enums.errorCodes[100000] = 'Неизвестная ошибка. Повторите попытку через некоторое время. При повторении ошибки' + ' свяжитесь с техподдержкой системы.';
Enums.errorCodes[100001] = 'Неверный логин или пароль.';
Enums.errorCodes[100002] = '';
Enums.errorCodes[100003] = '';
Enums.errorCodes[100004] = '';
Enums.errorCodes[100005] = '';
Enums.errorCodes[100006] = '';
Enums.errorCodes[100007] = 'Пароли не совпадают.';
Enums.errorCodes[100008] = 'Небезопасный пароль.';
Enums.errorCodes[100009] = 'Новый пароль не должен совпадать с паролями, использованными вами ранее.';
Enums.errorCodes[100010] = 'Неверный пароль';
Enums.errorCodes[100051] = 'Пользователь в Beekeeper не найден. Обратитесь к куратору';

Enums.errorCodesMaps['BACKEND_ERROR'] = 100000;

Enums.userHighlightTypes[1] = 'green-dark';
Enums.userHighlightTypes[2] = 'gray-dark';

Enums.userTypes[1] = 'Стажер';
Enums.userTypes[2] = 'Основной сотрудник';

Enums.ticketHighlightStatuses[1] = 'blue-dark';
Enums.ticketHighlightStatuses[2] = 'blue-dark';
Enums.ticketHighlightStatuses[3] = 'blue-dark';
Enums.ticketHighlightStatuses[7] = 'blue-dark';
Enums.ticketHighlightStatuses[4] = 'red-dark';
Enums.ticketHighlightStatuses[5] = 'red-dark';
Enums.ticketHighlightStatuses[9] = 'red-dark';
Enums.ticketHighlightStatuses[6] = 'gray-dark';
Enums.ticketHighlightStatuses[8] = 'gray-dark';

Enums.cellSquare[1] = 'blue-light';
Enums.cellSquare[2] = 'orange-light';
Enums.cellSquare[3] = 'pink-light';
Enums.cellSquare[4] = 'gray-pale';
Enums.cellSquare[5] = 'gray-pale';
Enums.cellSquare[6] = 'pink-light';
Enums.cellSquare[7] = 'gray-bright-light';
Enums.cellSquare[8] = 'gray-pale';
Enums.cellSquare[9] = 'green-light';

Enums.workShiftIntervalStatuses[1] = 'work-time';
Enums.workShiftIntervalStatuses[2] = 'lunch-time';
Enums.workShiftIntervalStatuses[3] = 'expiration-time';

Enums.workShiftIntervalSquare[1] = 'work-time';
Enums.workShiftIntervalSquare[2] = 'lunch-time';
Enums.workShiftIntervalSquare[3] = 'expiration-time';
Enums.workShiftIntervalSquare[3] = 'expiration-time';

Enums.workShiftTicketsIntervalSquare[3] = 'moved-time';
Enums.workShiftTicketsIntervalSquare[7] = 'work-time';

Enums.workShiftTicketsIntervalSquareGRS[1] = 'moved-time';
Enums.workShiftTicketsIntervalSquareGRS[2] = 'work-time';
Enums.workShiftTicketsIntervalSquareGRS[3] = 'expiration-time';
Enums.workShiftTicketsIntervalSquareGRS[4] = 'lunch-time';

Enums.workShiftTicketsIntervalMap[3] = 'В пути';
Enums.workShiftTicketsIntervalMap[7] = 'В работе';

Enums.tables['emptyDataMessage'] = 'По заданным критериям фильтра ничего не найдено.';
